var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 25C48.75 38.7216 37.8733 49.858 24.4445 49.858C11.0157 49.858 0.138916 38.7216 0.138916 25C0.138916 11.266 11.0157 0.14209 24.4445 0.14209C37.8733 0.14209 48.75 11.266 48.75 25Z",
    fill: "#283544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8605 20.2785C34.7393 20.3513 31.8525 21.8877 31.8525 25.2942C31.9886 29.1791 35.4955 30.5415 35.5556 30.5415C35.4955 30.6143 35.0262 32.3975 33.636 34.2667C32.5328 35.8768 31.3083 37.5001 29.4489 37.5001C27.6802 37.5001 27.0453 36.427 25.0044 36.427C22.8128 36.427 22.1927 37.5001 20.5146 37.5001C18.6552 37.5001 17.34 35.7898 16.1767 34.1948C14.6653 32.1072 13.3806 28.8312 13.3353 25.6856C13.3047 24.0188 13.638 22.3803 14.4839 20.9886C15.6778 19.0457 17.8093 17.7267 20.137 17.6832C21.9205 17.6256 23.5078 18.8575 24.5963 18.8575C25.6394 18.8575 27.5895 17.6832 29.7959 17.6832C30.7483 17.6842 33.288 17.9593 34.8605 20.2785ZM24.4454 17.3504C24.128 15.8282 25.0044 14.306 25.8208 13.3351C26.8639 12.1608 28.5113 11.3638 29.932 11.3638C30.0227 12.886 29.4479 14.3788 28.4206 15.4661C27.4988 16.6404 25.9115 17.5244 24.4454 17.3504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.61a8ed84d8aac9cefaea6572cec3cf14.svg";
export { ForwardRef as ReactComponent };